import React from 'react';
import {
  Create,
  ReferenceInput,
  SimpleForm,
  SelectInput,
  TextInput,
} from 'react-admin';

import { isRequired } from '../../validators';

import { PreviewFieldForCreateForm } from './PreviewField';


export default props => (
  <Create
    {...props}
    title="Send Push Notification"
  >
    <SimpleForm>
      <PreviewFieldForCreateForm />
      <TextInput source="title" />
      <TextInput source="body" validate={isRequired} required />

      <ReferenceInput
        label="Offering"
        source="custom.offerId"
        reference="offerings"
        filter={{ visibleToEndUsers: 1 }}
        allowEmpty
        perPage={100}
      >
        <SelectInput
          helperText="Optional. If value is set then when the user taps the the push notification the app will open to the offering. If not set then app will open to default screen"
          optionText={choice => `(${choice.name})`}
        />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);




// WEBPACK FOOTER //
// ./src/components/PushNotification/Create.js